import ServiceHelper from './ServiceHelper';
import IServiceHelper from './IServiceHelper';

/**
 * This factory class allows the BaseApiService to indirectly use features of
 * it concrete implementations while avoiding circular dependency issues.
 * "TypeError: Class extends value undefined is not a constructor or null"
 */
export default class ServiceHelperFactory {
    static getHelper(): IServiceHelper {
        return new ServiceHelper();
    }
}
